import { Theme } from "./Theme";

export const AntConfig = {
  token: {
    fontFamily: Theme.fonts.fontFamily,
  },
};
